import { PrismicNextImage } from "@prismicio/next";
import Styles from "./Scrolling.module.css";

const Scrolling = ({ items }) => {
	const logos = [...items, ...items];
	return (
		<section className={Styles.wrapper}>
			<div
				className={Styles.container}
				data-contain='true'>
				<div className={Styles.logoWrapper}>
					<div className={Styles.logoContainer}>
						{logos.map((item, index) => (
							<PrismicNextImage
								key={index}
								field={item.image}
								className={Styles.logo}
							/>
						))}
					</div>
				</div>
			</div>
		</section>
	);
};

export default Scrolling;
